export default "__VITE_ASSET__Djyv9Eat__"